import { TalentPoolPage } from '@/features/talent-pool/talent-pool-page'
import { lastActivityFilterSchema } from '@jobilla/nexus-sdk'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const talentPoolSearchSchema = z.object({
	q: z.string().optional(),
	last_activity: lastActivityFilterSchema.default('anytime'),
	page: z.number().int().min(1).default(1),
	peek: z.string().uuid().optional(),
})

export const Route = createFileRoute('/_auth/company/$companyId/talent-pool')({
	validateSearch: talentPoolSearchSchema,
	search: {
		middlewares: [
			({ next, search }) => {
				const cleaned: Record<string, unknown> = { ...search }
				if (cleaned.page === 1) {
					delete cleaned.page
				}
				if (!cleaned.q) {
					delete cleaned.q
				}
				if (!cleaned.peek) {
					delete cleaned.peek
				}
				if (cleaned.last_activity === 'anytime') {
					delete cleaned.last_activity
				}
				return next(cleaned)
			},
		],
	},
	component: RouteComponent,
})

function RouteComponent() {
	const { companyId } = Route.useParams()
	const search = Route.useSearch()
	return <TalentPoolPage search={search} companyId={companyId} />
}
